import { TableCell, useMediaQuery, useTheme } from "@mui/material"
import { Link } from "react-router-dom";

const TableCellLink = (params) => {
    return <TableCell padding="checkbox" align="center" component={Link} to={{
        pathname: `/product-details/${encodeURIComponent(params.product.productId)}`,
    }} sx={{ textDecoration: "none" }}  {...params} />
}

export const ProductBody = ({ product }) => {
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))
    const description =
        product.productDescription.length > 32
            ? `${product.productDescription.substring(0, 32)}...`
            : product.productDescription;
    return (
        <>
            <TableCellLink product={product}>{mobile ? description : product.productDescription}</TableCellLink>
            <TableCellLink product={product}>{product.productId}</TableCellLink>
            <TableCellLink product={product}>{product.unitPrice}</TableCellLink>
        </>
    )
}